import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <div className="font-serif text-xl text-slate-900">Dr. Jasmine Porwal</div>
          <div className="text-xs uppercase tracking-wider text-teal-700 mt-1">Medical Oncology</div>
          <p className="text-sm text-slate-600 mt-4 leading-relaxed">Evidence-based oncology consultations for patients in Delhi NCR, across India, and abroad.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 mb-3">Portal</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/book" className="hover:text-teal-700">Book Consultation</Link></li>
            <li><Link to="/resources" className="hover:text-teal-700">Clinical Resources</Link></li>
            <li><Link to="/faq" className="hover:text-teal-700">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-teal-700">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/privacy" className="hover:text-teal-700">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-teal-700">Terms of Service</Link></li>
            <li><Link to="/admin/login" className="hover:text-teal-700">Clinic Admin</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 mb-3">Credentials</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li>DM (Medical Oncology) — AIIMS</li>
            <li>MD (Internal Medicine) — PGIMER</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Dr. Jasmine Porwal. All consultations handled with strict confidentiality under DPDP Act (India) principles.
      </div>
    </footer>
  );
}
